import { render, staticRenderFns } from "./ResolveDispute.vue?vue&type=template&id=76f39ac1&scoped=true&"
import script from "./ResolveDispute.vue?vue&type=script&lang=js&"
export * from "./ResolveDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f39ac1",
  null
  
)

export default component.exports